<template>
  <div class="side-panel">
    <div class="text-center font available mb-8">
      {{ makeRub(balance_free) }}
    </div>
    <div class="text-center mb-10" v-if="acc">
      <span style="color: #717d83">На счет №: </span><span>***{{ accLastFourDigits }}</span>
    </div>
    <div class="details mb-8" v-if="!cantWithdraw">
      <div class="details__body">
        <div class="details__title">{{ fullname }}</div>
        <div class="details__item">
          <span class="details__key">ИНН:</span>
          <span class="details__value">{{ inn }}</span>
        </div>
        <div class="details__item">
          <span class="details__key">Банк:</span>
          <span class="details__value">{{ bank }}</span>
        </div>
        <div class="details__item">
          <span class="details__key">БИК:</span>
          <span class="details__value">{{ bic }}</span>
        </div>
        <div class="details__item">
          <span class="details__key">Счёт:</span>
          <span class="details__value">{{ acc }}</span>
        </div>
      </div>
    </div>
    <div class="not-available mb-6" v-else>
      <h3 class="font font--h3 mb-2">Невозможно вывести вознаграждение</h3>
      <div class="font font--p-sm">
        Для вывода вознаграждения заполните информацию в {{ whereNeedToFill }} пользовательских настроек
      </div>
    </div>
    <!-- <WithdrawalModulPopup /> -->
    <!-- <WithdrawalNoModulPopup /> -->
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";
import { makeRub } from "@/mixins/makeRub";
// import WithdrawalModulPopup from "@/components/common/WithdrawalModulPopup.vue";
// import WithdrawalNoModulPopup from "@/components/common/WithdrawalNoModulPopup.vue";

export default {
  mixins: [makeRub],

  components: {
    // WithdrawalModulPopup,
    // WithdrawalNoModulPopup,
  },
  computed: {
    ...mapState({
      balance_free: (state) => state.billing.balance_free,
      acc: (state) => state.profile.acc,
      firstname: (state) => state.profile.firstname,
      surname: (state) => state.profile.surname,
      middlename: (state) => state.profile.middlename,
      bankObj: (state) => state.profile.bank,
      withdrawalSidePanel: (state) => state.billing.withdrawalSidePanel,
    }),
    ...mapGetters("profile", ["reqIsNotFilled", "flNameIsNotFilled", "inn", "cantWithdraw"]),
    whereNeedToFill() {
      let text;
      if (this.flNameIsNotFilled && this.reqIsNotFilled) {
        text = "разделах Профиль и Реквизиты";
      } else {
        text = "разделе ";
        text += this.flNameIsNotFilled ? "Профиль" : this.reqIsNotFilled ? "Реквизиты" : "";
      }
      return text;
    },
    bank() {
      return this.bankObj && this.bankObj.bank;
    },
    bic() {
      return this.bankObj && this.bankObj.bic;
    },
    fullname() {
      return this.surname + " " + this.firstname + " " + this.middlename;
    },
    accLastFourDigits() {
      return this.acc.substring(this.acc.length - 4);
    },
    isModulBic() {
      if (this.withdrawalSidePanel) {
        if (this.bic === "044525092" || this.bic === "045004864" || this.bic === "043469751") {
          this.setModulBicPopup(true);
        } else {
          this.setNoModulBicPopup(true);
        }
      }
    },
  },
  watch: {
    withdrawalSidePanel(v) {
      if (v === true) {
        this.isModulBic;
      }
    },
  },
  methods: {
    ...mapMutations("profile", ["setModulBicPopup", "setNoModulBicPopup"]),
    createReport() {
      console.error("Report still not implemented");
    },
  },
};
</script>

<style lang="scss" scoped>
.not-available {
  background: #ffe9e9;
  border: 2px solid #d43d3d;
  box-shadow: 0px 4px 14px rgba(185, 53, 53, 0.12);
  border-radius: 4px;
  padding: 20px;
}

.details {
  background: #ffffff;
  border: 1px solid #cbcfd1;
  box-shadow: 0px 5px 13px rgba(0, 0, 0, 0.077757);

  &__body {
    padding: 24px 30px 50px;
    background: #f6f7f8;
    // border-bottom: 1px solid rgba(151, 151, 151, 0.4);
  }
  &__footer {
    padding: 28px 30px;
    font-style: italic;
    color: #717d83;
  }
  &__title {
    font-size: 20px;
    margin-bottom: 30px;
  }
  &__item {
    margin-bottom: 10px;
  }
  &__key {
    display: inline-block;
    min-width: 75px;
    color: rgba(0, 0, 0, 0.499972);
  }
}

.available {
  font-weight: 300;
  font-size: 60px;
  line-height: 70px;
}
</style>
